@if (tooltip !== '' || link !== '') {
  <div
    class="info-helper material-icons-outlined h-[25px] w-[25px] cursor-pointer relative flex items-center justify-center"
    [attr.aria-label]="ariaLabel"
    [ngStyle]="{
      'background-image': icon_custom
        ? 'url(/assets/images/icons/info-helper/' + icon_custom + '.svg)'
        : '',
    }"
    [matTooltip]="link ? '' : tooltip"
    [matTooltipPosition]="position"
  >
    {{ !icon_custom ? icon_material : '' }}

    @if (link !== '') {
      <a
        target="_blank"
        class="h-[25px] w-[25px] absolute left-0"
        [matTooltip]="tooltip === '' ? 'Open in a separate tab' : tooltip"
        aria-label="info-helper-link"
        (click)="link && link.length > 0 ? true : $event.preventDefault()"
        [href]="link"
      >
      </a>
    }
  </div>
} @else {
  <div
    class="info-helper material-icons-outlined h-[25px] w-[25px] cursor-pointer relative flex items-center justify-center"
    [attr.aria-label]="ariaLabel"
    [ngStyle]="{
      'background-image': icon_custom
        ? 'url(/assets/images/icons/info-helper/' + icon_custom + '.svg)'
        : '',
    }"
    [matMenuTriggerFor]="helper"
    #menuTrigger="matMenuTrigger"
    (mouseenter)="mouseEnter(menuTrigger)"
    (mouseleave)="mouseLeave(menuTrigger)"
  >
    {{ !icon_custom ? icon_material : '' }}
  </div>
  <mat-menu
    #helper="matMenu"
    xPosition="after"
    yPosition="below"
    [hasBackdrop]="!isMenuHover"
  >
    <span
      fxFlex="100"
      (mouseenter)="mouseEnter(menuTrigger)"
      (mouseleave)="mouseLeave(menuTrigger)"
    >
      <ng-template matMenuContent let-text="text">
        <div class="p-2">
          <ng-content></ng-content>
        </div>
      </ng-template>
    </span>
  </mat-menu>
}
